import React, { PropsWithChildren } from "react";

import {
  StyledCommandPaletteList,
  StyledHeading,
} from "./CommandPalette.styles";

export interface CommandPaletteListProps {
  heading?: string;
  visible?: boolean;
}

export const CommandPaletteList = ({
  children,
  heading,
  visible = false,
}: PropsWithChildren<CommandPaletteListProps>) => {
  return visible ? (
    <StyledCommandPaletteList className="cp-list" tabIndex={-1} role="listbox">
      {heading ? <StyledHeading tabIndex={-1}>{heading}</StyledHeading> : null}

      {children}
    </StyledCommandPaletteList>
  ) : null;
};

CommandPaletteList.displayName = "CommandPaletteList";
